// ============================================================
// ASTROLOG — Configuration centralisée du site
// Toutes les données de l'entreprise et les tarifs du calculateur
// sont modifiables ici, en un seul endroit.
// ============================================================

export const COMPANY = {
  name: "ASTROLOG",
  legalForm: "SAS",
  capital: "75 000,00 €",
  address: "8 Avenue du Président Coty",
  postalCode: "10600",
  city: "La Chapelle-Saint-Luc",
  country: "France",
  fullAddress: "8 Avenue du Président Coty, 10600 La Chapelle-Saint-Luc, France",
  rcs: "917 559 247 R.C.S. Troyes",
  siren: "917 559 247",
  siret: "917 559 247 00015",
  ape: "4941A — Transports routiers de fret interurbains",
  tva: "FR 41 917559247",
  euid: "FR1001.917559247",
  immatriculation: "18/07/2022",
  debutActivite: "01/07/2022",
  publicationDirector: "Monsieur AYEB Mohamed Anouar, Président",
  phone: "07 68 34 37 33",
  phoneIntl: "+33 7 68 34 37 33",
  phoneHref: "tel:+33768343733",
  email: "contact@astrolog.business",
  emailHref: "mailto:contact@astrolog.business",
  domain: "astrolog.business",
  url: "https://astrolog.business",
  host: {
    name: "Namecheap, Inc.",
    address: "4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis",
    phone: "+1 661 310 2107",
    site: "namecheap.com",
  },
  hours: "Lundi – vendredi : 8h00 – 18h00 · Samedi : 9h00 – 12h00 sur rendez-vous",
  zone: "France métropolitaine + Europe (Benelux, Allemagne, Espagne, Italie, Portugal, Suisse)",
  insurer: "AXA France IARD",
  mediator: {
    name: "CM2C — Centre de Médiation de la Consommation de Conciliateurs de Justice",
    address: "14 rue Saint Jean, 75017 Paris",
    phone: "01 89 47 00 14",
    email: "cm2c@cm2c.net",
    site: "www.cm2c.net",
  },
  devisValidite: "15 jours",
  reponseDelai: "24 heures ouvrées",
};

// ============================================================
// VÉHICULES ET TARIFS DU CALCULATEUR (données CNR 2025 / Upply)
// ============================================================
export const VEHICLES = [
  {
    id: "fourgon",
    name: "Fourgon / utilitaire léger",
    ptac: "< 3,5 T de PTAC",
    payload: 1200,
    volume: 20,
    priseEnCharge: 120,
    kmLow: 0.85,
    kmHigh: 1.15,
    usage: "Courses urbaines, colis, petites palettes, déménagements de studios",
    image:
      "https://images.unsplash.com/photo-1614976523626-d598aafd4fda?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "porteur-7t5",
    name: "Camion porteur 7,5 T",
    ptac: "7,5 T de PTAC",
    payload: 3000,
    volume: 30,
    priseEnCharge: 180,
    kmLow: 1.05,
    kmHigh: 1.45,
    usage: "Distribution régionale, palettes, déménagements T2/T3",
    image:
      "https://images.unsplash.com/photo-1519003722824-194d4455a60c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "porteur-12t",
    name: "Camion porteur 12 T",
    ptac: "12 T de PTAC",
    payload: 6000,
    volume: 40,
    priseEnCharge: 250,
    kmLow: 1.35,
    kmHigh: 1.85,
    usage: "Lots partiels, marchandises palettisées, transferts d'entreprise",
    image:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "porteur-19t",
    name: "Camion porteur 19 T",
    ptac: "19 T de PTAC",
    payload: 10000,
    volume: 50,
    priseEnCharge: 320,
    kmLow: 1.6,
    kmHigh: 2.15,
    usage: "Lots complets nationaux, fret industriel, gros déménagements",
    image:
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "semi-40t",
    name: "Semi-remorque 40 T",
    ptac: "40 T de PTRA",
    payload: 25000,
    volume: 90,
    priseEnCharge: 450,
    kmLow: 1.85,
    kmHigh: 2.55,
    usage: "Lots complets longue distance, France et Europe, 33 palettes",
    image:
      "https://images.unsplash.com/photo-1670509295484-df0c2512fec4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "porte-voitures",
    name: "Porte-voitures / Plateau",
    ptac: "Sur devis",
    payload: null,
    volume: null,
    priseEnCharge: null,
    kmLow: null,
    kmHigh: null,
    usage: "Transport de véhicules, engins de chantier, matériel agricole",
    image:
      "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
];

// Véhicules disponibles dans le calculateur (le porte-voitures est sur devis)
export const CALCULATOR_VEHICLES = VEHICLES.filter((v) => v.payload !== null);

export const PRICING_RULES = {
  minDistanceKm: 50,
  roadFactor: 1.25, // coefficient routier (Haversine × 1,25)
  maxWeightKg: 30000,
  weightSupplements: { mid: 50, high: 100 }, // 50-80% CU : +50 €, 80-100% : +100 €
  options: {
    demenagement: { lowPct: 0.15, highPct: 0.25 },
    hayon: { flat: 80 },
    urgence: { pct: 0.2 },
  },
};

// ============================================================
// SERVICES
// ============================================================
export const SERVICES = [
  {
    id: "transport-marchandises",
    icon: "Truck",
    title: "Transport routier de marchandises",
    description:
      "Lot complet ou groupage, partout en France et en Europe. Vos marchandises générales, palettes et colis voyagent en toute sécurité.",
    prestations: [
      "Lots complets (FTL) et lots partiels (LTL / groupage)",
      "Marchandises générales, palettes, colis, matériel",
      "Enlèvement et livraison à date convenue",
      "France métropolitaine et Europe",
    ],
  },
  {
    id: "location-conducteur",
    icon: "UserCheck",
    title: "Location de véhicules avec conducteurs",
    description:
      "Un camion et un chauffeur expérimenté pour une mission ponctuelle ou récurrente, sans investir dans une flotte.",
    prestations: [
      "Mise à disposition de 3,5 T à 40 T avec conducteur",
      "Missions ponctuelles ou contrats récurrents",
      "Chauffeurs titulaires de la FIMO/FCO à jour",
      "Facturation à la journée ou au forfait",
    ],
  },
  {
    id: "demenagement",
    icon: "PackageOpen",
    title: "Déménagement",
    description:
      "Particuliers et entreprises : nous organisons votre déménagement en France et en Europe, du simple transport à la formule complète.",
    prestations: [
      "Déménagement de particuliers (studios à maisons)",
      "Transferts d'entreprises et de bureaux",
      "Formule économique ou complète (emballage, montage)",
      "Manutention et protection du mobilier",
    ],
  },
  {
    id: "commissionnaire",
    icon: "Network",
    title: "Commissionnaire de transport",
    description:
      "Nous organisons et coordonnons vos flux de transport, y compris multimodaux, avec un interlocuteur unique.",
    prestations: [
      "Organisation de transports multimodaux",
      "Sélection et coordination de partenaires licenciés",
      "Suivi administratif et documentaire",
      "Optimisation des coûts et des délais",
    ],
  },
  {
    id: "transport-vehicules",
    icon: "CarFront",
    title: "Transport de véhicules et d'engins",
    description:
      "Porte-voitures et plateaux pour vos voitures, utilitaires, engins de chantier ou matériel agricole.",
    prestations: [
      "Voitures, utilitaires, motos",
      "Engins de chantier et matériel agricole",
      "Véhicules roulants ou non roulants",
      "Manutention sécurisée, arrimage professionnel",
    ],
  },
  {
    id: "transport-exceptionnel",
    icon: "Container",
    title: "Transport exceptionnel",
    description:
      "Charges hors gabarit et convois exceptionnels, étudiés au cas par cas avec les autorisations nécessaires.",
    prestations: [
      "Étude de faisabilité et itinéraire",
      "Demandes d'autorisations administratives",
      "Convoi exceptionnel catégories 1 à 3",
      "Sur devis uniquement",
    ],
  },
];

// ============================================================
// FAQ
// ============================================================
export const FAQ = [
  {
    q: "Comment obtenir un devis ?",
    a: "Utilisez notre calculateur en ligne pour une estimation immédiate, ou remplissez le formulaire de demande de devis. Vous pouvez aussi nous appeler au 07 68 34 37 33.",
  },
  {
    q: "Le devis est-il gratuit ?",
    a: "Oui, le devis est gratuit et sans engagement. Il est valable 15 jours à compter de sa date d'émission.",
  },
  {
    q: "Quels types de marchandises transportez-vous ?",
    a: "Marchandises générales, palettes, colis, véhicules, engins et matériel. Les matières dangereuses ne sont pas prises en charge.",
  },
  {
    q: "Intervenez-vous en Europe ?",
    a: "Oui : Benelux, Allemagne, Espagne, Italie, Portugal et Suisse. Destinations plus lointaines sur demande.",
  },
  {
    q: "Êtes-vous assuré pour les marchandises ?",
    a: "Oui. Nous disposons d'une assurance responsabilité civile professionnelle et d'une assurance marchandises transportées auprès d'AXA France IARD (couverture France + Union européenne). Attestation fournie sur simple demande.",
  },
  {
    q: "Quel est le délai pour un transport ?",
    a: "Il varie selon la distance et le véhicule. Nous répondons à toute demande sous 24 heures ouvrées avec un délai précis.",
  },
  {
    q: "Puis-je suivre mon transport ?",
    a: "Oui, des informations de suivi vous sont communiquées sur demande pendant toute la durée du transport.",
  },
  {
    q: "Comment se passe la facturation ?",
    a: "Acompte de 30 % à la commande, solde à la livraison, par virement bancaire ou carte bancaire. Pour les professionnels : virement à 30 jours fin de mois sur accord.",
  },
];

// ============================================================
// ZONE D'INTERVENTION
// ============================================================
export const ZONE = [
  { name: "France métropolitaine", detail: "Toutes régions, enlèvement et livraison" },
  { name: "Benelux", detail: "Belgique, Pays-Bas, Luxembourg" },
  { name: "Allemagne", detail: "Toutes régions industrielles" },
  { name: "Espagne", detail: "Péninsule ibérique" },
  { name: "Italie", detail: "Nord et centre principalement" },
  { name: "Portugal", detail: "Sur demande" },
  { name: "Suisse", detail: "Formalités douanières incluses" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1611746351408-c0a1346be8e8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920&auto=format&fit=crop",
  highway: "https://images.unsplash.com/photo-1501700493788-fa1a4fc9fe62?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format&fit=crop",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format&fit=crop",
  moving: "https://images.unsplash.com/photo-1698917414969-feade59e3343?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format&fit=crop",
  trucks: "https://images.unsplash.com/photo-1591768793355-74d04bb6608f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format&fit=crop",
};
